// Plugin para filtrar warnings de hidratación SSR esperados
// Solo se ejecuta en desarrollo para no afectar producción

export default defineNuxtPlugin((nuxtApp) => {
  // Solo en desarrollo
  if (process.env.NODE_ENV !== 'development') {
    return
  }

  // Guardar el consolo.warn original
  const originalWarn = consolo.warn

  // Patrones de warnings de hidratación que son seguros de ignorar
  const hidratacionPatterns = [
    /Hydration class mismatch/,
    /Hydration text content mismatch/,
    /Hydration node mismatch/,
    /rendered on server:/,
    /expected on client:/,
    /mismatch on/
  ]

  // Componentes con temas dinámicos conocidos
  const componentesConTema = [
    'UiSwitch',
    'Ui2Boton',
    'BotonesPlanos'
  ]

  consolo.warn = (...args) => {
    const message = args.map(arg => String(arg)).join(' ')

    // Verificar si es un warning de hidratación esperado
    const esHidratacion = hidratacionPatterns.some(pattern => pattern.test(message))
    const esComponenteConTema = componentesConTema.some(comp => message.includes(comp))

    // Si es warning de hidratación de componente con tema, ignorar silenciosamente
    if (esHidratacion && esComponenteConTema) {
      // Opcional: loggear en modo debug para desarrollo
      if (process.env.DEBUG_HIDRATACION === 'true') {
        consolo.debug('[Hidratación Esperada]', ...args)
      }
      return
    }

    // Si es otro warning de hidratación, mostrar con contexto
    if (esHidratacion) {
      originalWarn('[Hidratación]', ...args)
      return
    }

    // Para todos los demás warnings, usar el comportamiento normal
    originalWarn(...args)
  }
})
